import { isNullOrUndefined } from '@deltasierra/type-utilities';

/**
 * Asserts the value is defined and not null
 *
 * @param value - The null or undefined possible value
 * @param message - The optional message
 */
export function assertDefined<T>(
    value: T | null | undefined,
    message = 'Unexpected null or undefined value',
): asserts value is T {
    if (isNullOrUndefined(value)) {
        throw new Error(message);
    }
}
